import { render, staticRenderFns } from "./GeneralCampusWorkLoadAvg.vue?vue&type=template&id=4b017fe9"
import script from "./GeneralCampusWorkLoadAvg.vue?vue&type=script&lang=js"
export * from "./GeneralCampusWorkLoadAvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b017fe9')) {
      api.createRecord('4b017fe9', component.options)
    } else {
      api.reload('4b017fe9', component.options)
    }
    module.hot.accept("./GeneralCampusWorkLoadAvg.vue?vue&type=template&id=4b017fe9", function () {
      api.rerender('4b017fe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/GeneralCampusWorkLoadAvg.vue"
export default component.exports